// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1wnuJV","disabledInfo":"_2Yi23Y","useNewDesign":"cnTHdf","replacementInfo":"_2Ywhgx","replacementLink":"_1IRaVG"};